import anime from 'animejs';
import { SplitText } from '@/assets/libs/SplitText';

export function paragraphInit(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const split = new SplitText(ctx, { type: 'lines', linesClass: 'paragraph__line' });

  anime.set(split.lines, { translateY: 20, opacity: 0 });
}

export function paragraphAnim(el, delay = 0) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const lines = [...ctx.querySelectorAll('.paragraph__line')];
  const tween = anime({
    targets: lines,
    translateY: 0,
    opacity: 1,
    duration: 800,
    easing: 'easeOutCirc',
    delay: anime.stagger(100, { start: delay }),
  });

  return tween;
}
